angular
    .module("skillBuilderSaaS")
    .directive("formSubmitter", ["$timeout", formSubmitterDirective]);
function formSubmitterDirective($timeout) {
    return {
        restrict: "E",
        replace: true,
        template: "<form action=\"{{ formData.url }}\" method=\"{{ formData.method }}\">" +
            "   <div ng-repeat=\"(key,val) in formData.params\">" +
            "       <input type=\"hidden\" name=\"{{ key }}\" value=\"{{ val }}\" />" +
            "   </div>" +
            "</form>",
        link: function ($scope, $element) {
            $scope.$on("form.submit", function (_event, data) {
                $scope.formData = data;
                console.log("auto submitting form...");
                $timeout(function () {
                    $element.submit();
                });
            });
        }
    };
}
